const updateProductVariant = async (variantId, updateData) => {
  const response = await fetch('/api/shopify/product/update-variant', {
    method: 'POST',
    body: JSON.stringify({ id: variantId, ...updateData }),
  });
  const updatedProduct = await response.json();
  return updatedProduct;
};

export default updateProductVariant;
